import { actionTypes } from './actions';

export const reducer = (action) => ({
  [actionTypes.PARSELY_SET_CURRENT_CONSENT]: () => ({
    currentConsent: action.payload.consent,
  }),
  [actionTypes.PARSELY_SET_CONSENT_OPTION_SELECTED]: () => ({
    consentOptionSelected: action.payload.consentOptionSelected,
  }),
  [actionTypes.PARSELY_OPEN_MODAL_PRIVACY]: () => ({
    showModalPrivacy: true,
    currentWidgetHtmlId: action.payload.currentWidgetHtmlId,
  }),
  [actionTypes.PARSELY_CLOSE_MODAL_PRIVACY]: () => ({
    showModalPrivacy: false,
    currentWidgetHtmlId: null,
  }),
});
